import createRouter from "router5";
import loggerPlugin from "router5-plugin-logger";
import browserPlugin from "router5-plugin-browser";
import routes from "./routes";

import transitionPath from "router5-transition-path";

// from ["root", "bar", "baz"] to [["root"], ["root", "bar"], ["root", "bar", "baz"]]
const buildAllSegments = (segments) => {
  return segments
    .map((x, i) => segments.slice(0, segments.length - i))
    .reverse();
};

// collect all onActive attribute associated to a route, then run it
const dataMiddlewareFactory =
  (routes) => (router) => (toState, fromState, arg1, arg2) => {
    const transition = transitionPath(toState, fromState);
    const onActivateHandlers = transition.toActivate.flatMap((route) => {
      return routes.find((r) => r.name === route).onActivate;
    });

    // get all intersection routes
    const intersection_routes = buildAllSegments(
      transition.intersection.split(".").filter((x) => x !== ""),
    ).map((segments) => segments.join("."));

    const intersection_handlers = intersection_routes.flatMap((route) => {
      return routes.find((r) => r.name === route).onActivate;
    });

    // what should be reused, what should be sent again?
    // by default: cache everything
    const reload = toState.meta.options?.reload_keys || [];

    let to_fetch = [],
      cache = {};
    intersection_handlers.forEach((handler) => {
      if (reload.includes(handler.k)) {
        to_fetch.push(handler);
      } else {
        cache[handler.k] = fromState.data[handler.k];
      }
    });

    const all_handlers = onActivateHandlers.concat(to_fetch);

    return Promise.all(
      all_handlers.map(({ cb }) => cb(toState, fromState, transition)),
    ).then((data) => {
      const routeData = data.reduce(
        (accData, rData) => Object.assign(accData, rData),
        cache,
      );
      return { ...toState, data: routeData };
    });
  };

// const basepath = process.env.PUBLIC_URL;
const basepath = "/desktop";

export default function configureRouter(defaultRoute) {
  const router = createRouter(routes, {
    defaultRoute: defaultRoute,
    trailingSlashMode: "never",
  });

  router.usePlugin(loggerPlugin);
  router.usePlugin(browserPlugin());

  router.useMiddleware(dataMiddlewareFactory(routes));

  router.setRootPath(basepath);

  return router;
}
